import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import { log } from '@/component-create/utils/log';
import * as Icons from '@element-plus/icons-vue';

import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XIcon',
  props: {
    icon: {}
  },
  setup: function setup(__props) {
    var prop = __props;
    var icon = computed(function () {
      if (prop.icon.includes('el-icon-')) {
        var key = prop.icon.replace('el-icon-', '').split('-').map(function (item) {
          return item[0].toLocaleUpperCase() + item.slice(1);
        }).join('');
        if (!Icons[key]) {
          log('XIcon', "\u8BE5\u56FE\u6807\u4E0D\u5B58\u5728\uFF1A".concat(prop.icon), 'error');
          return null;
        }
        return Icons[key];
      }
    });
    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");
      return _unref(icon) ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon))))];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});